type SweethLogoProps = {
  className?: string;
};

export default function SweethLogo({ className }: SweethLogoProps) {
  return (
    <svg
      className={className}
      aria-label="Sweeth Logo"
      version="1.1"
      width="1006.668"
      height="220.77867"
      viewBox="0 0 1006.668 220.77867"
      xmlns="http://www.w3.org/2000/svg">
      <defs id="defs1">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath2">
          <path
            d="M 0,165.584 H 755.001 V 0 H 0 Z"
            transform="translate(-347.50521,-101.1292)"
            id="path2"
          />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath4">
          <path
            d="M 0,165.584 H 755.001 V 0 H 0 Z"
            transform="translate(-62.640802,-5.4749976)"
            id="path4"
          />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath6">
          <path
            d="M 0,165.584 H 755.001 V 0 H 0 Z"
            transform="translate(-226.6294,-8.0816002)"
            id="path6"
          />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath8">
          <path
            d="M 0,165.584 H 755.001 V 0 H 0 Z"
            transform="translate(-618.40972,-11.339698)"
            id="path8"
          />
        </clipPath>
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath10">
          <path
            d="M 0,165.584 H 755.001 V 0 H 0 Z"
            transform="translate(-693.76522,-102.3848)"
            id="path10"
          />
        </clipPath>
      </defs>
      <g id="layer-MC0">
        <path
          id="path1"
          fill="currentColor"
          d="M 0,0 C 16.146,-0.503 30.62,-10.454 33.33,-23.183 H -33.965 C -30.306,-9.414 -15.681,0.487 0,0 m 170.845,-59.464 c -3.934,-5.273 -8.501,-9.8 -15.007,-12.535 -9.876,-4.152 -19.949,-5.326 -30.124,-1.727 -13.414,4.746 -23.57,18.728 -22.858,31.332 h 94.868 c -0.566,5.854 -0.609,11.193 -1.662,16.333 -4.386,21.401 -16.827,36.76 -38.219,43.225 C 135.523,23.909 114.737,20.483 97.461,3.619 80.562,-12.876 63.558,-29.27 46.573,-45.682 39.05,-52.953 31.947,-60.739 23.8,-67.273 c -17.184,-13.779 -41.897,-10.735 -54.134,6.08 -3.951,5.428 -6.24,11.472 -6.693,18.669 h 4.985 c 22.067,0 44.137,-0.056 66.203,0.101 1.918,0.014 4.23,1.002 5.662,2.283 4.852,4.343 9.309,9.105 14.088,13.528 1.836,1.698 2.299,3.228 1.592,5.639 C 44.225,17.519 2.566,28.712 -27.405,14.233 -52.882,1.925 -65.622,-30.16 -55.993,-56.732 c 5.611,-15.483 15.038,-28.383 31.188,-34.23 25.26,-9.147 48.704,-6.094 68.543,13.191 22.982,22.335 45.989,44.645 68.868,67.081 14.295,14.019 38.755,14.173 53.003,0.087 3.563,-3.521 6.004,-7.663 7.584,-12.888 h -4.806 c -17.55,-0.001 -35.102,-0.067 -52.651,0.063 -2.838,0.021 -4.801,-0.815 -6.755,-2.761 -7.953,-7.928 -15.992,-15.78 -24.151,-23.505 -2.017,-1.91 -2.66,-3.586 -1.7,-6.244 4.978,-13.79 13.085,-25.187 26.178,-32.645 10.865,-6.19 22.832,-7.408 35.156,-6.887 21.918,0.928 42.381,15.427 50.267,36.006 z"
          transform="matrix(1.3333333,0,0,-1.3333333,463.34027,85.939733)"
          clipPath="url(#clipPath2)"
        />
        <path
          id="path3"
          fill="currentColor"
          d="m 0,0 c -35.307,0 -56.832,13.471 -57.556,39.11 0,0.871 0.724,1.522 1.693,1.522 h 24.908 c 0.968,0 1.693,-0.651 1.693,-1.522 0.727,-14.991 11.367,-21.729 30.955,-21.729 16.446,0 26.36,5.867 26.36,16.297 0,24.771 -82.707,2.825 -82.707,48.89 0,22.6 20.313,34.548 51.752,34.548 30.955,0 52.721,-11.732 54.414,-35.2 0,-0.868 -0.725,-1.519 -1.693,-1.519 H 26.12 c -0.968,0 -1.693,0.651 -1.934,1.519 -1.693,11.736 -10.882,18.252 -27.328,18.252 -14.51,0 -23.7,-4.781 -23.7,-15.645 0,-24.117 82.708,-1.303 82.708,-48.671 C 55.866,13.036 32.164,0 0,0"
          transform="matrix(1.3333333,0,0,-1.3333333,83.521067,213.47867)"
          clipPath="url(#clipPath4)"
        />
        <path
          id="path5"
          fill="currentColor"
          d="M 0,0 C -0.968,0 -1.937,0.652 -2.177,1.522 L -25.395,89.523 -45.708,1.522 C -45.708,0.652 -46.677,0 -47.642,0 h -30.715 c -0.968,0 -1.933,0.652 -2.177,1.522 l -29.503,108.862 c -0.243,0.868 0.241,1.519 1.209,1.519 h 25.876 c 0.969,0 1.934,-0.651 1.934,-1.519 l 19.348,-88.22 20.797,88.22 c 0,0.868 0.968,1.519 1.937,1.519 h 31.68 c 0.968,0 1.933,-0.651 1.933,-1.519 l 20.557,-86.481 19.348,86.481 c 0,0.868 0.968,1.519 1.933,1.519 h 23.703 c 0.965,0 1.449,-0.651 1.209,-1.519 L 32.889,1.522 C 32.648,0.652 31.68,0 30.712,0 Z"
          transform="matrix(1.3333333,0,0,-1.3333333,302.17253,210.0032)"
          clipPath="url(#clipPath6)"
        />
        <path
          id="path7"
          fill="currentColor"
          d="m 0,0 c 0,-0.868 -0.725,-1.736 -1.69,-1.955 -5.807,-1.739 -13.303,-3.258 -20.073,-3.258 -19.591,0 -37.243,8.907 -37.243,33.897 V 89.09 h -14.269 c -0.968,0 -1.693,0.652 -1.693,1.52 v 16.516 c 0,0.868 0.725,1.519 1.693,1.519 h 14.269 l -0.243,26.51 c 0,0.868 0.724,1.519 1.693,1.519 h 25.876 c 0.968,0 1.693,-0.651 1.693,-1.519 l -0.241,-26.51 h 28.779 c 0.968,0 1.693,-0.651 1.693,-1.519 V 90.61 c 0,-0.868 -0.725,-1.52 -1.693,-1.52 h -28.779 l 0.241,-59.755 c 0,-11.3 5.079,-14.777 14.509,-14.777 5.564,0 10.158,0.871 13.788,1.739 C -0.725,16.516 0,15.864 0,15.213 Z"
          transform="matrix(1.3333333,0,0,-1.3333333,824.54627,205.65907)"
          clipPath="url(#clipPath8)"
        />
        <path
          id="path9"
          fill="currentColor"
          d="m 0,0 c -14.025,0 -27.329,-9.997 -31.68,-28.465 l 0.484,-64.316 c 0,-0.871 -0.728,-1.522 -1.693,-1.522 h -25.395 c -0.965,0 -1.693,0.651 -1.693,1.522 l 0.728,75.181 -0.728,73.877 c 0,0.868 0.728,1.523 1.693,1.523 h 25.395 c 0.965,0 1.693,-0.655 1.693,-1.523 L -31.44,2.826 c 8.225,10.645 21.041,17.381 38.937,17.381 27.329,0 44.015,-14.775 43.29,-47.368 V -50.41 l 0.481,-42.371 c 0,-0.871 -0.724,-1.522 -1.69,-1.522 H 23.459 c -0.969,0 -1.693,0.651 -1.693,1.522 l 0.484,41.936 v 26.509 C 22.006,-7.387 12.576,0 0,0"
          transform="matrix(1.3333333,0,0,-1.3333333,925.02027,84.2656)"
          clipPath="url(#clipPath10)"
        />
      </g>
    </svg>
  );
}
